<template>
  <ul class="push-list">
    <PushCard
      v-for="(push, index) in $content.push"
      :key="index"
      class="push-card"
      :push="push"
    />
  </ul>
</template>

<script>
import PushCard from '@/components/layouts/push/PushCard.vue';

export default {
  name: 'PushList',
  components: {
    PushCard,
  },
  data() {
    return {
      // Add your component data here
    };
  },
  computed: {
    // Add your computed properties here
  },
  mounted() {
    // Add your mounted lifecycle hook here
  },
  methods: {
    // Add your component methods here
  },
};
</script>

<style lang="stylus" scoped>
.push-list {
  display: flex;
  gap: 15px
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: $content-width;
  margin: 25px auto;

  +mobile(){
    flex-direction: column;
  }
}
</style>
